export default "__VITE_ASSET__B9K9J2Wc__"